"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AppPaySystemsListCtl = /** @class */ (function (_super) {
    __extends(AppPaySystemsListCtl, _super);
    function AppPaySystemsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_apikey = UIUtils_1.UIUtils.IProp2Str(function (o) { o.apikey; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_payway_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.payway_count; });
        _this.dk_callback_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.callback_url; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    AppPaySystemsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    AppPaySystemsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    AppPaySystemsListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListInnerPayServicesGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    apikey: resp.list[i].apikey,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    payway_count: resp.list[i].payway_count,
                    callback_url: resp.list[i].callback_url
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppPaySystemsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddInnerPayService.exec({
            data: {
                title: data.title,
                apikey: data.apikey,
                is_locked: data.is_locked,
                description: data.description,
                callback_url: data.callback_url,
                brand_id: data.brand_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                apikey: data.apikey,
                callback_url: data.callback_url,
                is_locked: data.is_locked,
                description: data.description,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                payway_count: 0
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppPaySystemsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditInnerPayService.exec({
                data: {
                    inner_pay_service_id: data.key,
                    title: data.title,
                    apikey: data.apikey,
                    is_locked: data.is_locked,
                    description: data.description,
                    callback_url: data.callback_url
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.apikey = data.apikey;
                _tmp.is_locked = data.is_locked;
                _tmp.description = data.description;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.callback_url = data.callback_url;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppPaySystemsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AppPaySystemsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteInnerPayService.exec({ data: { inner_pay_service_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppPaySystemsListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetInnerPayServiceIsLocked.exec({ data: { inner_pay_service_id: key, is_locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppPaySystemsListCtl.prototype.DoTestBlockChainApi = function (onDone) {
        var _this = this;
        webAApi_1.DoTestBlockChainApi.exec({}, function (resp) {
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return AppPaySystemsListCtl;
}(BaseController_1.BaseController));
exports.AppPaySystemsListCtl = AppPaySystemsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem/ctl/AppPaySystemsListCtl.ts
// module id = 1053
// module chunks = 0